/**
 * Opening a settings URL directly (refresh, link, bookmark) showed two loaders:
 * the boot loader while the user and permissions load, then — only once the
 * shell rendered — a second one while the lazy settings chunk downloaded,
 * restarting the spinner in a new spot. Starting that download during boot runs
 * it alongside the bootstrap requests, so the chunk is usually ready by the time
 * the shell renders and the second loader never shows.
 *
 * Must import the same module as the `Settings` route in `components/getRoutes`
 * so both resolve to one chunk.
 */
let requested = false;

export const isSettingsPath = (pathname: string): boolean =>
  pathname === '/settings' || pathname.startsWith('/settings/');

export const preloadSettingsRoute = (): void => {
  if (requested) return;
  requested = true;
  import('@/pages/settings').catch(() => {
    // A failed preload must not surface — React.lazy retries on navigation.
    requested = false;
  });
};
